import { RangePreset } from "../types";

export function startOfDay(d: Date): Date {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

export function addDays(d: Date, n: number): Date {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}

export function toISODate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function parseISODate(value?: string): Date | null {
  if (!value) return null;
  const d = new Date(`${value}T00:00:00`);
  return Number.isNaN(d.getTime()) ? null : startOfDay(d);
}

export function daysBetween(a: Date, b: Date): number {
  return Math.round((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
}

export function formatTick(d: Date): string {
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

export function formatRangeShort(a: Date, b: Date): string {
  const opts: Intl.DateTimeFormatOptions = { month: "short", day: "numeric" };
  const yearOpts: Intl.DateTimeFormatOptions = { ...opts, year: "numeric" };
  if (a.getFullYear() !== b.getFullYear()) {
    return `${a.toLocaleDateString("en-US", yearOpts)} – ${b.toLocaleDateString("en-US", yearOpts)}`;
  }
  return `${a.toLocaleDateString("en-US", opts)} – ${b.toLocaleDateString("en-US", yearOpts)}`;
}

export const RANGE_PRESETS: RangePreset[] = [
  {
    id: "15d",
    label: "15 days",
    hint: "From today",
    build: () => {
      const start = startOfDay(new Date());
      return { start, end: addDays(start, 14) };
    },
  },
  {
    id: "30d",
    label: "30 days",
    hint: "From today",
    build: () => {
      const start = startOfDay(new Date());
      return { start, end: addDays(start, 29) };
    },
  },
  {
    id: "this-month",
    label: "This month",
    hint: "Calendar month",
    build: () => {
      const now = new Date();
      return {
        start: startOfDay(new Date(now.getFullYear(), now.getMonth(), 1)),
        end: startOfDay(new Date(now.getFullYear(), now.getMonth() + 1, 0)),
      };
    },
  },
  {
    id: "2-months",
    label: "2 months",
    hint: "From today",
    build: () => {
      const start = startOfDay(new Date());
      const end = new Date(start);
      end.setMonth(end.getMonth() + 2);
      return { start, end: startOfDay(addDays(end, -1)) };
    },
  },
  {
    id: "3-months",
    label: "3 months",
    hint: "From today",
    build: () => {
      const start = startOfDay(new Date());
      const end = new Date(start);
      end.setMonth(end.getMonth() + 3);
      return { start, end: startOfDay(addDays(end, -1)) };
    },
  },
  {
    id: "next-quarter",
    label: "90 days",
    hint: "From today",
    build: () => {
      const start = startOfDay(new Date());
      return { start, end: addDays(start, 89) };
    },
  },
];
